import { Controller } from '../utils/controller';

export default class extends Controller {
  static targets = ['rotatingPromo'];
  static requiredTargets = [];
  static classes = ['hide'];
  static requiredClasses = [];
  static values = {
    rotateInterval: Number
  };

  // TARGETS
  declare rotatingPromoTargets: HTMLDivElement[];

  // VALUES
  declare rotateIntervalValue: number | undefined;

  // CLASES
  declare hideClass: string;

  // LOCAL STATE
  private currentPromoIndex: number;
  private rotatingInterval: number | undefined;

  initialize() {
    this.currentPromoIndex = 0;
    this.rotatingInterval = undefined;
    this.replayStart();
  }

  replayStart() {
    this.rotatingInterval && clearInterval(this.rotatingInterval);
    this.rotatingInterval = setInterval(this.rotatePromo, this.rotateIntervalValue);
  }

  setCurrentIndex(direction = 'next') {
    this.currentPromoIndex =
      direction === 'next'
        ? this.currentPromoIndex === this.rotatingPromoTargets.length - 1
          ? 0
          : this.currentPromoIndex + 1
        : this.currentPromoIndex === 0
        ? this.rotatingPromoTargets.length - 1
        : this.currentPromoIndex - 1;
  }

  setCurrentClasses() {
    for (let i = 0; i < this.rotatingPromoTargets.length; i++) {
      if (i !== this.currentPromoIndex) {
        this.rotatingPromoTargets[i].classList.add(this.hideClass);
        continue;
      }
      this.rotatingPromoTargets[i].classList.remove(this.hideClass);
    }
  }

  rotatePromo = () => {
    this.setCurrentIndex('next');
    this.setCurrentClasses();
  };

  prevSlide() {
    this.setCurrentIndex('prev');
    this.setCurrentClasses();
    this.replayStart();
  }

  nextSlide() {
    this.rotatePromo();
    this.replayStart();
  }
}
